// Lets code inspect (and stop) a popstate before Turbo handles it. popstate listeners on window run
// in registration order, capture or not, so this module must be imported before Turbo starts.
type PopStateGuard = (event: PopStateEvent) => void;

const guards = new Set<PopStateGuard>();

window.addEventListener("popstate", (event) => {
  for (const guard of guards) guard(event);
});

export function addPopStateGuard(guard: PopStateGuard) {
  guards.add(guard);
}

export function removePopStateGuard(guard: PopStateGuard) {
  guards.delete(guard);
}
